import React from 'react'
import PropTypes from 'prop-types'

import * as Styled from './BackToSearch.styles'

class BackToSearch extends React.PureComponent {
  constructor(props) {
    super(props)
    const { window } = this.props
    this.state = {
      show: false,
      referrer: window && window.document.referrer,
      host: window && window.location.host
    }
  }

  componentDidMount() {
    const { host, referrer } = this.state
    const pattern = new RegExp(`^http(s)?://${host}/search/`)
    if (pattern.exec(referrer)) {
      this.setState({
        show: true
      })
    }
  }

  returnToSearchListPage = () => window.history.back()

  render() {
    const { show, referrer } = this.state
    const { message } = this.props

    if (!referrer) return null
    return (
      <Styled.Container show={show} data-test={`back-to-search-show-${show}`} className='back-to-search'>
        <a data-test='back-to-search-link' onClick={this.returnToSearchListPage}>
          {message}
        </a>
      </Styled.Container>
    )
  }
}

BackToSearch.propTypes = {
  window: PropTypes.object,
  message: PropTypes.string
}

BackToSearch.defaultProps = {
  window: global.window && window,
  message: 'Back to search results'
}
export default BackToSearch
